var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper-body flex-1"},[_c('ListCorrespondences',{attrs:{"nodeId":_vm.nodeId,"selectionMode":'multi'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }